import { StateController } from '../state';

export function setPageMetaTitle(title: string) {
  document.title = title;
  document
    .querySelector('meta[property="og:title"]')
    ?.setAttribute('content', title);
}

export function setPageMetaDescription(description: string) {
  ['meta[name="description"]', 'meta[property="og:description"]'].forEach(
    (selector: string) => {
      document.querySelector(selector)?.setAttribute('content', description);
    }
  );
}

export function removeImageMeta() {
  ['meta[property="og:image"]', 'meta[property="og:image:alt"]'].forEach(
    (selector: string) => {
      document.querySelector(selector)?.remove();
    }
  );
}

export function setPageMetadata() {
  const titleTemplate = '__ | Umbraco Marketplace';
  const templateKey = '__';

  const setDefaults = () => {
    setPageMetaTitle('Umbraco Marketplace | Umbraco integrations and packages');
    setPageMetaDescription(
      'Browse and find the best Umbraco integrations and packages on the official Umbraco Marketplace | Extend your Umbraco project'
    );
  };

  if (!StateController.isPackageView) {
    removeImageMeta();
  }

  if (StateController.isCategoryView) {
    const categoryName =
      StateController.current.categories?.find(
        x => x.link === window.location.pathname
      )?.name ?? '';

    if (!categoryName) {
      setDefaults();
      return;
    }

    setPageMetaTitle(titleTemplate.replace(templateKey, categoryName));

    setPageMetaDescription(
      `Extend your Umbraco website with ${categoryName} | Find available packages and integrations on the Umbraco Marketplace`
    );
  } else if (StateController.isTypeView) {
    const typename = StateController.current.filter?.packageType;

    if (!typename) {
      setDefaults();
      return;
    }

    setPageMetaTitle(`${typename}s available on the Umbraco Marketplace`);
    setPageMetaDescription(
      `Browse all ${typename}s available on the official Umbraco Marketplace | Find information, links, and install instructions for each`
    );
  } else if (StateController.isSearchView) {
    setPageMetaTitle('Search on the Umbraco Marketplace');
    setPageMetaDescription(
      'Search for Umbraco Integrations and Packages on the official Umbraco Marketplace'
    );
  } else if (
    StateController.current.pageTitle &&
    StateController.current.pageDescription
  ) {
    setPageMetaTitle(
      titleTemplate.replace(templateKey, StateController.current.pageTitle)
    );
    setPageMetaDescription(StateController.current.pageDescription);
  } else {
    setDefaults();
  }
}
